import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { agent } from "../../../utils/agent";
import * as API from "../../../utils/apiPath";

// LOAD PENDING REQUESTS
export const loadPendingRequestData = createAsyncThunk(
    "mentees/loadPendingRequestData",
    async ({ status, request }) => {
        const res = await agent.get(
            `${API.LOAD_CUSTOMER}/customerPendingRequest/${status}`,
            { params: request }
        );
        return {
            data: res?.data?.data?.data,
            pagination: res?.data?.data?.pagination
        };
    }
);

export const loadRegPendingRequestData = createAsyncThunk(
    "mentees/loadRegPendingRequestData",
    async ({ status, request }) => {
        const res = await agent.get(
            `${API.PENDING_REG_MENTEE_REQUEST}/${status}`,
            { params: request }
        );
        return {
            data: res?.data?.data?.data,
            pagination: res?.data?.data?.pagination,
            steps_labels: res?.data?.data?.steps_labels || {},
        };
    }
);

// ACCEPT / REJECT REQUEST
export const assignMentorRequest = createAsyncThunk(
    "mentees/assignMentorRequest",
    async (payload) => {
        const res = await agent.post(API.ASSIGN_MENTOR_REQUEST, payload);
        return res.data;
    }
);

const menteesRequestSlice = createSlice({
    name: "menteesRequest",
    initialState: {
        menteeRequestData: [],
        pagination: {},
        steps_labels: {},
        loading: false,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(loadPendingRequestData.pending, (state) => {
                state.loading = true;
            })
            .addCase(loadPendingRequestData.fulfilled, (state, action) => {
                state.loading = false;
                state.menteeRequestData = action.payload.data;
                state.pagination = action.payload.pagination;
            })
            .addCase(assignMentorRequest.fulfilled, (state, action) => {
                // Optionally filter out removed/accepted rows
            })
            .addCase(loadRegPendingRequestData.pending, (state) => {
                state.loading = true;
            })
            .addCase(loadRegPendingRequestData.fulfilled, (state, action) => {
                state.loading = false;
                state.menteeRequestData = action.payload.data;
                state.pagination = action.payload.pagination;
                state.steps_labels = action.payload.steps_labels;
            });
    },
});

export default menteesRequestSlice.reducer;
